import { gql } from '@apollo/client'

export const GET_ALL_SPECIAL_ING = gql`
  query AllPieces(
    $str: String
    $state: StateEnumOperationFilterInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [TaxonomySpecialIngFunctionalUnitsGraphQLSortInput!]
  ) {
    state: __type(name: "StateEnum") {
      name
      enumValues {
        name
        description
      }
    }
    taxonomySpecialFunctionalUnit: __type(name: "TaxonomySpecialIngFunctionalUnitsGraphQL") {
      fields {
        name
        description
      }
    }

    taxonomySpecialFunctionalUnits(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        id: { gt: 0 }
        or: [
          { state: $state }
          { code: { contains: $str } }
          { class: { contains: $str } }
          { category: { contains: $str } }
          { functionalUnit: { contains: $str } }
          { functionalUnitProxy: { contains: $str } }
          { lastUpdatedName: { contains: $str } }
          { researcherName: { contains: $str } }
        ]
      }
      order: $order
    ) {
      totalCount
      edges {
        node {
          id
          code
          state
          class
          category
          functionalUnit
          functionalUnitProxy
          transportCondition
          isVerified
          verifiedOn
          lastPublishedDate
          lastUpdatedName
          updated
          researcherName
          created
        }

        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
